// Páginas do Recuperador de Vendas (antes eram popups em Campanhas).
export const ROTA_CONFIG_RECUPERADOR = "/admin/impulsione/campanhas/recuperador-de-vendas";
export const ROTA_RELATORIO_RECUPERADOR = "/admin/impulsione/relatorio-ofertas/campanhas/recuperador-de-vendas";
